
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  name: 'GoodsCard'
})
export default class GoodsCard extends Vue {
  @Prop({ default: true }) isUse?: boolean
  @Prop({ default: false }) showAnimation?: boolean // 是否展示动画
  @Prop({ default: () => {} }) data!: any

  specShow = false
  minData = {}
}
